/**
 * TSS Necker Quote — the SW necker designer (shopify-designer-app assets/swnd-designer.js) in quote mode.
 *
 * Same guided flow and the same class contract as the designer stylesheet. Differences from the SW port:
 *   1. No prices anywhere, and no product/variants: styles come straight from the synced data files.
 *   2. Quantity minimum is a hint, not a block (step 1 is a quote, TSS decides).
 *   3. Step 4 collects the group's details; submit POSTs multipart form data to the app proxy, which
 *      creates the Shopify draft order. Colours are sent by NAME only, keyed by section name — hex is
 *      used to draw the preview and never leaves the browser.
 *
 * ?nq_debug=1 logs the payload and shows the thank-you screen without sending anything.
 */
(function () {
	'use strict';

	var $ = function (id) { return document.getElementById(id); };
	var app = $('swnd-app');
	if (!app) { return; }

	var CFG = window.NeckerQuote || {};
	var DEBUG = /[?&]nq_debug=1/.test(window.location.search);
	var MOQ = CFG.moqHint || 10;

	// ------------------------------------------------------------- data

	function buildData() {
		var maps = window.ScoutwiseSectionMaps || {};
		var tpls = window.ScoutwiseTemplates || {};
		var styles = {};
		(window.ScoutwiseStyles || []).forEach(function (s) {
			if (!tpls[s.slug] || !maps[s.slug]) { return; }
			var sections = [];
			Object.keys(maps[s.slug]).forEach(function (cls) {
				if (maps[s.slug][cls] !== 'n/a') { sections.push({ 'class': cls, name: maps[s.slug][cls] }); }
			});
			styles[s.slug] = { label: s.label, sections: sections, svg: tpls[s.slug] };
		});
		var palette = (window.ScoutwisePalette || []).map(function (c) {
			return { name: c.name, hex: c.hex, allowed_sections: c.allowedSections || '' };
		});
		return { styles: styles, palette: palette };
	}

	var D = buildData();
	if (!Object.keys(D.styles).length) {
		console.warn('[necker-quote] no styles resolved — check the data assets');
		return;
	}

	var booted = false;
	var submitted = false;
	var state = { style: null, styleChosen: false, colours: {}, activeSection: null, step: 1 };

	// ------------------------------------------------------------- helpers

	function styleData() { return D.styles[state.style]; }

	function swatchByName(name) {
		for (var i = 0; i < D.palette.length; i++) {
			if (D.palette[i].name === name) { return D.palette[i]; }
		}
		return null;
	}

	function isLight(hex) {
		var h = hex.replace('#', '');
		if (h.length === 3) { h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2]; }
		return (0.299 * parseInt(h.substr(0, 2), 16) +
			0.587 * parseInt(h.substr(2, 2), 16) +
			0.114 * parseInt(h.substr(4, 2), 16)) > 186;
	}

	/** Reflective is border-and-centre-stripe only. */
	function swatchAllowed(swatch, sectionName) {
		if (!swatch.allowed_sections) { return true; }
		if (swatch.allowed_sections === 'border-or-stripe') { return /border|stripe/i.test(sectionName); }
		return true;
	}

	function sections() { return styleData().sections; }
	function colouredCount() { return sections().filter(function (s) { return !!state.colours[s['class']]; }).length; }
	function allColoured() { return colouredCount() === sections().length; }

	function quantities() {
		return {
			junior: Math.max(0, parseInt($('quantity-junior').value, 10) || 0),
			adult: Math.max(0, parseInt($('quantity-adult').value, 10) || 0)
		};
	}
	function hasQuantity() { var q = quantities(); return q.junior + q.adult > 0; }

	// ------------------------------------------------------------- canvas

	function renderCanvas() {
		$('main-image').innerHTML = styleData().svg;
		$('style-chip').textContent = styleData().label;
		paint();
	}

	function paint() {
		var svg = $('main-image').querySelector('svg');
		if (!svg) { return; }
		sections().forEach(function (sec) {
			var name = state.colours[sec['class']];
			var sw = name ? swatchByName(name) : null;
			Array.prototype.forEach.call(svg.querySelectorAll('.' + sec['class']), function (el) {
				el.style.fill = sw ? sw.hex : '';
			});
		});
		updateProgress();
	}

	function updateProgress() {
		var done = colouredCount();
		var total = sections().length;
		var pct = total ? Math.round((done / total) * 100) : 0;
		$('meta-progress-fill').style.width = pct + '%';
		$('meta-progress-label').textContent = done === total ? 'Design complete' : done + ' of ' + total + ' coloured';
		var track = app.querySelector('.progress-track');
		if (track) { track.setAttribute('aria-valuenow', String(pct)); }
		app.querySelector('.meta-progress').classList.toggle('is-complete', total > 0 && done === total);
	}

	function preview(sectionClass, hex) {
		var svg = $('main-image').querySelector('svg');
		if (!svg) { return; }
		Array.prototype.forEach.call(svg.querySelectorAll('.' + sectionClass), function (el) { el.style.fill = hex; });
	}

	function endPreview(sectionClass) {
		var name = state.colours[sectionClass];
		var sw = name ? swatchByName(name) : null;
		preview(sectionClass, sw ? sw.hex : '');
	}

	// ------------------------------------------------------------- step 1

	function renderStyles() {
		var grid = $('styles-grid');
		grid.innerHTML = '';
		Object.keys(D.styles).forEach(function (slug) {
			var btn = document.createElement('button');
			btn.type = 'button';
			btn.className = 'necker-style' + (slug === state.style && state.styleChosen ? ' active-style' : '');
			btn.title = D.styles[slug].label;
			btn.innerHTML = '<span class="thumb">' + D.styles[slug].svg + '</span><span class="label"></span>';
			btn.querySelector('.label').textContent = D.styles[slug].label;
			btn.addEventListener('click', function () { selectStyle(slug, true); });
			grid.appendChild(btn);
		});
	}

	function selectStyle(slug, userChose) {
		var changed = state.style !== slug;
		state.style = slug;
		if (changed) { state.colours = {}; state.activeSection = null; }
		if (userChose) { state.styleChosen = true; }
		renderStyles();
		renderCanvas();
		renderSections();
		refresh();
	}

	// ------------------------------------------------------------- step 2

	function renderSections() {
		var list = $('sections-list');
		list.innerHTML = '';

		sections().forEach(function (sec) {
			var cls = sec['class'];
			var chosen = state.colours[cls];
			var sw = chosen ? swatchByName(chosen) : null;

			var card = document.createElement('div');
			card.className = 'section-card' + (state.activeSection === cls ? ' is-active' : '');
			card.dataset.id = cls;

			var head = document.createElement('div');
			head.className = 'section-head';
			head.innerHTML = '<span class="name"></span><span class="hint"></span><span class="current-swatch"></span>';
			head.querySelector('.name').textContent = sec.name;
			head.querySelector('.hint').textContent = chosen || 'Not coloured';
			if (sw) { head.querySelector('.current-swatch').style.background = sw.hex; }
			head.addEventListener('click', function (ev) {
				ev.preventDefault();
				state.activeSection = (state.activeSection === cls) ? null : cls;
				renderSections();
			});
			card.appendChild(head);

			var grid = document.createElement('div');
			grid.className = 'palette-grid';
			D.palette.forEach(function (c) {
				var allowed = swatchAllowed(c, sec.name);
				var b = document.createElement('button');
				b.type = 'button';
				b.className = 'swatch-btn' + (chosen === c.name ? ' is-selected' : '');
				b.style.background = c.hex;
				b.setAttribute('data-name', c.name);
				if (isLight(c.hex)) { b.setAttribute('data-light', 'true'); }
				b.title = allowed ? c.name : c.name + ' — borders and the centre stripe only';
				b.setAttribute('aria-label', b.title);
				if (!allowed) {
					b.disabled = true;
				} else {
					b.addEventListener('mouseenter', function () { preview(cls, c.hex); });
					b.addEventListener('focus', function () { preview(cls, c.hex); });
					b.addEventListener('mouseleave', function () { endPreview(cls); });
					b.addEventListener('blur', function () { endPreview(cls); });
					b.addEventListener('click', function () { pick(cls, c); });
				}
				grid.appendChild(b);
			});
			card.appendChild(grid);
			list.appendChild(card);
		});

		if (state.activeSection === null) {
			var next = sections().filter(function (s) { return !state.colours[s['class']]; })[0];
			if (next) {
				state.activeSection = next['class'];
				var el = list.querySelector('.section-card[data-id="' + next['class'] + '"]');
				if (el) { el.classList.add('is-active'); }
			}
		}
	}

	function pick(sectionClass, swatch) {
		state.colours[sectionClass] = swatch.name;
		var remaining = sections().filter(function (s) { return !state.colours[s['class']]; })[0];
		state.activeSection = remaining ? remaining['class'] : null;
		renderSections();
		paint();
		refresh();
	}

	// ------------------------------------------------------------- steps

	function openStep(n) {
		if (n >= 3 && !allColoured()) { return; }
		if (n >= 4 && !hasQuantity()) { return; }
		state.step = n;
		app.setAttribute('data-mstep', String(n));
		Array.prototype.forEach.call(app.querySelectorAll('.step-block'), function (block) {
			var s = parseInt(block.dataset.step, 10);
			block.classList.toggle('is-open', s === n);
			block.querySelector('.step-head').setAttribute('aria-expanded', s === n ? 'true' : 'false');
		});
		updateStepChrome();
		scrollToApp();
	}

	function scrollToApp(force) {
		if (!booted && !force) { return; }
		var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
		app.scrollIntoView({ block: 'start', behavior: reduce ? 'auto' : 'smooth' });
	}

	function setStepCta(block, ready, readyLabel, blockedLabel) {
		var btn = block.querySelector('.step-next');
		if (!btn) { return; }
		btn.disabled = !ready;
		btn.querySelector('.step-next-label').textContent = ready ? readyLabel : blockedLabel;
	}

	function updateBackToDesigner() {
		var btn = $('back-to-designer');
		if (!btn) { return; }
		var doc = document.documentElement;
		var scrolled = window.scrollY / Math.max(1, doc.scrollHeight - window.innerHeight);
		var appBottom = app.getBoundingClientRect().bottom;
		btn.hidden = !(scrolled >= 0.5 && appBottom < 0);
	}

	function updateStepChrome() {
		var q = quantities();

		var block1 = app.querySelector('.step-block[data-step="1"]');
		block1.classList.toggle('is-done', !!state.style);
		app.querySelector('[data-status="1"]').textContent = state.style ? styleData().label : '';
		setStepCta(block1, state.styleChosen, 'Continue to colours', 'Choose a style to continue');

		var block2 = app.querySelector('.step-block[data-step="2"]');
		block2.classList.toggle('is-done', allColoured());
		app.querySelector('[data-status="2"]').textContent = allColoured()
			? colouredCount() + ' colours'
			: (colouredCount() ? colouredCount() + ' of ' + sections().length : 'Not started');
		setStepCta(block2, allColoured(), 'Continue to quantity', 'Colour every section to continue');

		var block3 = app.querySelector('.step-block[data-step="3"]');
		block3.classList.toggle('is-gated', !allColoured());
		block3.classList.toggle('is-done', hasQuantity());
		block3.querySelector('.step-status').textContent = hasQuantity() ? (q.junior + q.adult) + ' total' : 'Not set';
		setStepCta(block3, hasQuantity(), 'Continue to your details', 'Enter a quantity to continue');

		var block4 = app.querySelector('.step-block[data-step="4"]');
		block4.classList.toggle('is-gated', !(allColoured() && hasQuantity()));
	}

	/** Below 10 per size is allowed — TSS quotes it — but say so, so nobody is surprised. */
	function quantityHint() {
		var q = quantities();
		var below = [];
		if (q.junior > 0 && q.junior < MOQ) { below.push('Junior'); }
		if (q.adult > 0 && q.adult < MOQ) { below.push('Adult'); }
		return below.length
			? 'Neckers are usually made in ' + MOQ + 's or more per size (' + below.join(' and ') + '). We\'ll confirm in your quote.'
			: '';
	}

	// ------------------------------------------------------------- summary

	function refresh() {
		var q = quantities();
		$('sum-style').textContent = styleData().label;
		$('sum-jr-qty').textContent = q.junior;
		$('sum-ad-qty').textContent = q.adult;

		var hint = quantityHint();
		var warn = $('warning-message');
		warn.textContent = hint;
		warn.classList.toggle('show', !!hint);

		$('nq-submit').disabled = !(allColoured() && hasQuantity());
		updateStepChrome();
	}

	function toast(msg) {
		var t = $('toast');
		t.textContent = msg;
		t.classList.add('show');
		setTimeout(function () { t.classList.remove('show'); }, 2600);
	}

	// ------------------------------------------------------------- form

	var form = $('nq-form');

	function field(name) { return form.elements[name]; }

	function syncUploadLabel() {
		var reorder = (form.querySelector('input[name="order_type"]:checked') || {}).value === 'Reorder of our existing necker';
		$('nq-upload-label').innerHTML = reorder
			? 'Photo of your current necker <em>(optional, but it helps)</em>'
			: 'Photo or reference image <em>(optional)</em>';
	}

	// ------------------------------------------------------------- upload drop zone

	function fileSize(n) { return n > 1048576 ? (n / 1048576).toFixed(1) + ' MB' : Math.max(1, Math.round(n / 1024)) + ' KB'; }

	function showFile() {
		var input = field('upload');
		var file = input.files && input.files[0];
		var thumb = $('nq-file-thumb');
		if (thumb.dataset.url) { URL.revokeObjectURL(thumb.dataset.url); delete thumb.dataset.url; }
		$('nq-drop').hidden = !!file;
		$('nq-file').hidden = !file;
		if (!file) { return; }
		$('nq-file-name').textContent = file.name;
		var max = CFG.maxUploadBytes || 10485760;
		$('nq-file-size').textContent = fileSize(file.size) + (file.size > max ? ' — too big, 10 MB max' : '');
		$('nq-file-size').style.color = file.size > max ? '#c0392b' : '';
		if (/^image\//.test(file.type)) {
			thumb.dataset.url = URL.createObjectURL(file);
			thumb.style.backgroundImage = 'url("' + thumb.dataset.url + '")';
			thumb.textContent = '';
		} else {
			thumb.style.backgroundImage = '';
			thumb.textContent = (file.name.split('.').pop() || 'FILE').toUpperCase().slice(0, 4);
		}
	}

	function initDrop() {
		var drop = $('nq-drop');
		var input = field('upload');
		input.addEventListener('change', showFile);
		$('nq-file-remove').addEventListener('click', function () { input.value = ''; showFile(); });
		['dragenter', 'dragover'].forEach(function (t) {
			drop.addEventListener(t, function (e) { e.preventDefault(); drop.classList.add('is-over'); });
		});
		['dragleave', 'dragend', 'drop'].forEach(function (t) {
			drop.addEventListener(t, function () { drop.classList.remove('is-over'); });
		});
		drop.addEventListener('drop', function (e) {
			e.preventDefault();
			var files = e.dataTransfer && e.dataTransfer.files;
			if (!files || !files.length) { return; }
			try { input.files = files; } catch (err) { return; }
			showFile();
		});
	}

	// ------------------------------------------------------------- site header offset

	/** Visible height of the theme's sticky header, so the designer's own sticky parts sit below it. */
	var siteHeader = document.getElementById('shopify-section-header') ||
		document.querySelector('.shopify-section-group-header-group, header');
	function syncHeaderOffset() {
		var top = 0;
		if (siteHeader) {
			var pos = getComputedStyle(siteHeader).position;
			if (pos === 'sticky' || pos === 'fixed') { top = Math.max(0, Math.round(siteHeader.getBoundingClientRect().bottom)); }
		}
		app.style.setProperty('--nq-top', top + 'px');
	}

	/** First problem with the form, focusing the field it is about. Empty string = valid. */
	function formProblem() {
		form.classList.add('was-validated');
		var checks = [
			['name', 'Enter your name.'],
			['phone', 'Enter a phone number.'],
			['email', 'Enter your email address.'],
			['group', 'Enter your scout group.'],
			['county', 'Choose your county.']
		];
		for (var i = 0; i < checks.length; i++) {
			var el = field(checks[i][0]);
			if (!el.value.trim()) { el.focus(); return checks[i][1]; }
		}
		if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(field('email').value.trim())) { field('email').focus(); return 'Check your email address.'; }
		if (field('phone').value.replace(/\D/g, '').length < 7) { field('phone').focus(); return 'Check your phone number.'; }
		if (!form.querySelector('input[name="order_type"]:checked')) { return 'Tell us if this is a new design or a reorder.'; }
		if (!form.querySelector('input[name="fulfilment"]:checked')) { return 'Choose delivery or collection.'; }
		var file = field('upload').files[0];
		if (file && file.size > (CFG.maxUploadBytes || 10485760)) { return 'That file is over 10 MB — please choose a smaller one.'; }
		if (!field('consent').checked) { field('consent').focus(); return 'Please tick the box so we can contact you about your quote.'; }
		return '';
	}

	/** Colour map keyed by section NAME, colour NAME only. */
	function coloursByName() {
		var out = {};
		sections().forEach(function (s) { if (state.colours[s['class']]) { out[s.name] = state.colours[s['class']]; } });
		return out;
	}

	/** PNG of the coloured design, for the draft order and the staff email. Resolves null on failure. */
	function previewPng() {
		return new Promise(function (resolve) {
			try {
				var src = $('main-image').querySelector('svg');
				if (!src) { return resolve(null); }
				var svg = src.cloneNode(true);
				svg.setAttribute('width', '1000');
				svg.setAttribute('height', '1000');
				var xml = new XMLSerializer().serializeToString(svg);
				var img = new Image();
				img.onload = function () {
					var c = document.createElement('canvas');
					c.width = 1000; c.height = 1000;
					var ctx = c.getContext('2d');
					ctx.fillStyle = '#ffffff';
					ctx.fillRect(0, 0, 1000, 1000);
					ctx.drawImage(img, 0, 0, 1000, 1000);
					c.toBlob(function (b) { resolve(b); }, 'image/png');
				};
				img.onerror = function () { resolve(null); };
				img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(xml);
			} catch (e) { resolve(null); }
		});
	}

	function payload(png) {
		var q = quantities();
		var fd = new FormData();
		var design = {
			style: styleData().label,
			template: state.style,
			colours: coloursByName(),
			junior: q.junior,
			adult: q.adult
		};
		fd.append('design', JSON.stringify(design));
		['name', 'phone', 'email', 'group', 'county', 'needed_by', 'notes', 'website'].forEach(function (n) {
			fd.append(n, field(n).value.trim());
		});
		fd.append('order_type', form.querySelector('input[name="order_type"]:checked').value);
		fd.append('fulfilment', form.querySelector('input[name="fulfilment"]:checked').value);
		fd.append('consent', field('consent').checked ? 'yes' : 'no');
		fd.append('marketing', field('marketing').checked ? 'yes' : 'no');
		fd.append('page', window.location.pathname);
		var file = field('upload').files[0];
		if (file) { fd.append('upload', file, file.name); }
		if (png) { fd.append('preview', png, 'necker-preview.png'); }
		return fd;
	}

	function showError(msg) {
		var el = $('nq-submit-error');
		el.textContent = msg;
		el.classList.toggle('show', !!msg);
	}

	function submit() {
		if (submitted || !allColoured() || !hasQuantity()) { return; }
		if (state.step !== 4) { openStep(4); return; }
		var problem = formProblem();
		if (problem) { showError(problem); return; }
		showError('');

		var btn = $('nq-submit');
		btn.disabled = true;
		btn.classList.add('is-busy');

		previewPng().then(function (png) {
			var fd = payload(png);
			if (DEBUG) {
				var shown = {};
				fd.forEach(function (v, k) { shown[k] = v instanceof Blob ? '[file ' + v.size + ' bytes]' : v; });
				console.log('[necker-quote] DEBUG — not sent', shown);
				return { ok: true, body: { ok: true, debug: true } };
			}
			return fetch(CFG.endpoint || '/apps/necker-quote/submit', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
				.then(function (r) {
					return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok && j.ok !== false, body: j }; });
				});
		}).then(function (res) {
			if (!res.ok) { throw new Error((res.body && res.body.error) || 'We couldn\'t send your request. Please try again, or call us.'); }
			submitted = true;
			done(res.body);
		}).catch(function (e) {
			showError(e && e.message ? e.message : 'We couldn\'t send your request. Please try again, or call us.');
			btn.disabled = false;
			btn.classList.remove('is-busy');
		});
	}

	function done() {
		var q = quantities();
		var spec = $('nq-done-spec');
		spec.innerHTML = '';
		var rows = [['Style', styleData().label]];
		var byName = coloursByName();
		Object.keys(byName).forEach(function (k) { rows.push([k, byName[k]]); });
		if (q.junior) { rows.push(['Junior', String(q.junior)]); }
		if (q.adult) { rows.push(['Adult', String(q.adult)]); }
		rows.forEach(function (r) {
			var dt = document.createElement('dt'); dt.textContent = r[0];
			var dd = document.createElement('dd'); dd.textContent = r[1];
			spec.appendChild(dt); spec.appendChild(dd);
		});
		$('nq-done-email').textContent = field('email').value.trim();
		app.classList.add('is-submitted');
		$('nq-done').hidden = false;
		$('nq-done').focus();
		scrollToApp(true);
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({ event: 'tss_necker_quote_submit', necker_style: styleData().label, necker_qty: q.junior + q.adult });
		if (typeof window.fbq === 'function') { window.fbq('track', 'Lead', { content_name: 'Necker quote' }); }
	}

	function startAgain() {
		submitted = false;
		form.reset();
		form.classList.remove('was-validated');
		$('quantity-junior').value = 0;
		$('quantity-adult').value = 0;
		state.colours = {};
		state.activeSection = null;
		state.styleChosen = false;
		app.classList.remove('is-submitted');
		$('nq-done').hidden = true;
		var btn = $('nq-submit');
		btn.classList.remove('is-busy');
		syncUploadLabel();
		showFile();
		renderStyles();
		renderSections();
		paint();
		refresh();
		openStep(1);
	}

	// ------------------------------------------------------------- wiring

	function stepper(inputId, delta) {
		var input = $(inputId);
		var v = Math.max(0, (parseInt(input.value, 10) || 0) + delta);
		// Stepping up from nothing jumps straight to the usual minimum.
		if (delta > 0 && v > 0 && v < MOQ) { v = MOQ; }
		input.value = v;
		refresh();
	}

	function init() {
		['quantity-junior', 'quantity-adult'].forEach(function (id) { $(id).addEventListener('input', refresh); });
		$('inc-junior').addEventListener('click', function () { stepper('quantity-junior', 1); });
		$('dec-junior').addEventListener('click', function () { stepper('quantity-junior', -1); });
		$('inc-adult').addEventListener('click', function () { stepper('quantity-adult', 1); });
		$('dec-adult').addEventListener('click', function () { stepper('quantity-adult', -1); });

		$('reset-colours').addEventListener('click', function () {
			state.colours = {};
			state.activeSection = null;
			renderSections();
			paint();
			refresh();
		});

		Array.prototype.forEach.call(app.querySelectorAll('.step-head'), function (head) {
			head.addEventListener('click', function () { openStep(parseInt(head.closest('.step-block').dataset.step, 10)); });
		});
		Array.prototype.forEach.call(app.querySelectorAll('.step-next[data-next]'), function (b) {
			b.addEventListener('click', function () { openStep(parseInt(b.dataset.next, 10)); });
		});

		Array.prototype.forEach.call(form.querySelectorAll('input[name="order_type"]'), function (r) {
			r.addEventListener('change', syncUploadLabel);
		});
		form.addEventListener('submit', function (e) { e.preventDefault(); submit(); });
		form.addEventListener('input', function () { if (form.classList.contains('was-validated')) { showError(''); } });

		$('nq-submit').addEventListener('click', submit);
		$('nq-again').addEventListener('click', startAgain);

		var back = $('back-to-designer');
		if (back) { back.addEventListener('click', function () { scrollToApp(true); }); }

		var scrollTick = false;
		window.addEventListener('scroll', function () {
			if (scrollTick) { return; }
			scrollTick = true;
			window.requestAnimationFrame(function () {
				scrollTick = false;
				var top = app.getBoundingClientRect().top;
				var vh = window.innerHeight / 100;
				if (!app.classList.contains('is-scrolled')) {
					if (top < -10 * vh) { app.classList.add('is-scrolled'); }
				} else if (top > -1 * vh) {
					app.classList.remove('is-scrolled');
				}
				updateBackToDesigner();
				syncHeaderOffset();
			});
		}, { passive: true });
		window.addEventListener('resize', syncHeaderOffset);
		syncHeaderOffset();
		initDrop();

		selectStyle(Object.keys(D.styles)[0], false);
		openStep(1);
		booted = true;
		if (DEBUG) { toast('Debug mode — nothing will be sent'); }
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
